import { Component, OnInit, Renderer2, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwSecurityUserService, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, 
         DwMetaDataFormApi, DwEventService, DwGridDeleteActionService, DwContextService, DwModalService,
         DwMetaDataService, DwMetaDataServiceToken, DwModalConfig, DwModalButtonStandardConfigs, DwModalSize,
         getParameterByName, DwMessagingService, DwMessageSeverity } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { FleetMetaDataItemNames, FleetMetaDataLookups, AuctionEntity, BidHistoryEntity,RoVehicleEntity, RoAuctionEntity,
         RoEthosUserEntity, CodeValueFleetAuctionStatus } 
         from '../meta-data/fleet-meta-data.service';
import { FleetAuctionContextService } from '../../../customizations/fleet/data-contexts/auction-responsibility-context.service'
import { NoteControlNewComponent } from '../../../shared/notes/note-control-new/components/note-control-new.component';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import { QueryString } from '../../../shared/services/querystring.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as moment_ from 'moment';
import { re } from 'mathjs';
import { map, mergeMap, concatMap, mergeAll, toArray, concatAll, shareReplay, delay, first } from 'rxjs/operators';
import { NotesRepositoryService } from 'src/app/shared/notes/services/notes-repository-service';
const moment = moment_;

@DwComponent(
  {
    key: 'add-bid-history',
    name: 'Add Bid History',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
    selector: 'add-bid-history',
    template: `
<div class="bidHistory-containerClass">
    <div dwRow>
        <div dwCol="12" class="add-bid-history">
            <i class="fa-duotone fa-square-dollar"></i>
            <input type="number" [disabled]="rules.isSelf" step="0.1" class="bid-amount" (input)="checkBid()" [(ngModel)]="amount">&nbsp;
            <button [hidden]="!good" type="button" (click)="saveBid()" 
                class="btn-sm btn-success add-new-bid" title="">Save Bid</button>
            <div class="bid-rules">
            <span [ngClass]="rules.isSelf ? 'bid-na' : rules.initial ? 'bid-orange' : 'bid-red'">1. Initial bid amount must be equal to or greater than the Starting Price</span><br>
            <span [ngClass]="rules.isSelf ? 'bid-na' : rules.higher ? 'bid-orange' : 'bid-red'">2. If a bid exists, amount must be greater than the highest bid</span><br>
            <span [ngClass]="rules.isSelf ? 'bid-red' : 'bid-na'">3. You cannot bid to increase your own bid</span>
            </div>
        </div>
</div>
  `,
  styleUrls: ['./add-bid-history.component.scss'],
})
export class AddBidHistoryComponent 
    implements OnInit, DoCheck, OnDestroy {

    good: boolean = false;
    amount: number = undefined;
    formApi: DwMetaDataFormApi;
    auction : AuctionEntity;

    constructor(private dwSecurityUserService: DwSecurityUserService,
            private dwGridDeleteActionService : DwGridDeleteActionService,
            private queryString : QueryString,
            private messageService:  DwMessagingService,
            @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
            @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
            private dwEventService: DwEventService,
            private dwModalService: DwModalService,
            private dwContextService: DwContextService,
            private notesRepository: NotesRepositoryService,
            private dwFormStateService: DwMetaDataFormStateService) 
    {
        this.formApi = dwFormStateService.state.formApi;
        this.auction = this.formApi.getFormData(); 
        this.retrieveRealTimeCurrentBid(this.auction).subscribe(data => this.good = this.isGoodBid(data));
    }

    rules = { initial: false, higher: false, isSelf: false }
    subscriptions: Subscription[] = [];
    roUser : RoEthosUserEntity;
    auctionEntity: AuctionEntity;
    ngOnInit(): void {
        const addBid = this.queryString.exists('AddBid');
        if (addBid)
            this.publishResponsibility(false);

        this.getRoUser().subscribe(ru => this.roUser = ru);

        this.auction = this.formApi.getFormData();
        this.calcDuration(this.auction);
        this.dwContextService.getContextsAndResolve([FleetAuctionContextService.ContextName], 
                                                    { data: this.auction, formApi: this.formApi })
            .subscribe(cxt => this.publishResponsibility(cxt?.FleetAuctionContext?.Responsible));
    }
    publishResponsibility(resp: boolean){
        if (resp != undefined)
            this.notesRepository.publishNoteReadOnlyEvent('Auction', !resp);   
    }
   
    calcDuration(i : AuctionEntity){
        let duration: string = '<span style="font-weight: bold;" class="auction-duration">Auto-populates based <br>on Start / End Dates</span>';
        const ed = moment(i.EndDateTime);
        const sd = moment(i.StartDateTime);
        const now = moment(this.currentDateTime);
        if (ed.isValid() == true && sd.isValid() == true && ed > sd){
            const diffMs = ed.valueOf() - sd.valueOf();
            duration = (Math.round(diffMs / (10*60*60))/100).toString();
        }
        else if (this.formApi.getVariableContextValue()?.Duration == duration) 
            return;
        this.formApi.patchVariableContext({ Duration: duration });
    }
    currentBid? : number = undefined;
    roAuc: RoAuctionEntity;
    retrieveRealTimeCurrentBid(auc : AuctionEntity) : Observable<number> {
        return auc.AuctionId == undefined ? of(null) :
                this.dataService.loadEntity(FleetMetaDataItemNames.RoAuction, auc.AuctionId)
                   .pipe(map(data => {
                        this.roAuc = data;
                        return this.roAuc.CurrentBid;
                   }));
    }
    isGoodBid(updateCurrent: number = undefined) : boolean{
        this.auction = this.formApi.getFormData(); 
        this.currentBid = updateCurrent ?? this.currentBid;

        this.rules.initial = this.amount > this.auction.StartingPrice;
        this.rules.higher = this.currentBid == undefined || this.amount > this.currentBid;
        this.rules.isSelf = this.roAuc?.CreatedByUserId == this.currentUserId ||
                            this.roAuc?.AppUserId == this.appUserId;
        return this.rules.initial && this.rules.higher && !this.rules.isSelf;
    }
    checkBid(){
        /* For now we are going to save checking against current bid until final save */
        if (this.currentBid != undefined)
            this.good = this.isGoodBid();
        else if (this.auction.VehicleId > 0)
            this.retrieveRealTimeCurrentBid(this.auction)
                .subscribe(data => this.good = this.isGoodBid(data));
    }
    showUnderBidDialog(){
        let mc = new DwModalConfig();
        mc.buttons = [ DwModalButtonStandardConfigs.instance.okButton ];
        mc.modalSize = DwModalSize.small;
        mc.content = 'Another bidder raised the current bid.<br>Please increase your bid.';
        mc.title = 'You were outbid';
        return this.dwModalService.showModal(mc)
                   .pipe(map(result => 
                    {
                        this.getAuction(this.auction.AuctionId)
                            .subscribe(a => {
                                this.formApi.patchFormData({ BidHistory: a.BidHistory });
                            });
                        return { success: result };
                     }));
    }
    saveBid(){
        this.auction = this.formApi.getFormData(); 
        this.retrieveRealTimeCurrentBid(this.auction)
            .subscribe(data => {
                this.good = this.isGoodBid(data);

                if (this.good != true)
                    this.showUnderBidDialog();
                else {
                    const bid : BidHistoryEntity = this.dataService.createDummyEntity(FleetMetaDataItemNames.BidHistory);
                    bid.AuctionId = this.auction.AuctionId;
                    bid.BidderName = this.currentUserId > 0 ? this.roUser?.NameFirstLast 
                                                            : this.dwSecurityUserService.securityContext.ApplicationUser.FirstNameLastName;
                    bid.Amount = this.amount;
                    bid.CreatedByDateTime = this.currentDateTime;
                    bid.CreatedByUserId = this.currentUserId;
                    bid.AppUserId = this.appUserId;
                    this.dataService.saveEntity(bid)
                        .pipe(catchError(err => { 
                            this.messageService.showMessage({
                                messageHeading: 'Bid was not submitted!', 
                                messageBody: err.error.detail.split(';')[0], 
                                timeToShow : 3000,
                                severity: DwMessageSeverity.warning 
                            });
                            return of({});
                        }))
                        .subscribe(i => {
                            if (i?.BidHistoryId > 0){
                                const bids = this.auction.BidHistory ?? [];
                                bids.push(i);
                                this.formApi.patchFormData({ BidHistory: bids });
                                this.currentBid = this.amount;
                                this.rules.isSelf = true;
                            }
                            else
                                this.formApi.patchFormData({ StatusCv: CodeValueFleetAuctionStatus.CompletedEnded });
                            this.amount = null;
                            this.good = false;
                        });
                }
        
            });
    }

    ngOnDestroy(): void {
        for(const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    ngDoCheck(): void{
    }
    private currentDateTime: string = moment().utc().format("MM/DD/YYYY hh:mm A");
    private currentUserId: number = new WachterUserExt(this.dwSecurityUserService.securityContext.ApplicationUser)
                                                        .trustUserId;
    private appUserId: number = this.dwSecurityUserService.securityContext.ApplicationUser.UserId;
    getRoUser() : Observable<RoEthosUserEntity>{
        return this.dataService.loadEntity(FleetMetaDataItemNames.RoEthosUser, this.currentUserId)
    }
    getAuction(aucId : number) : Observable<AuctionEntity> {
        return this.dataService.loadEntity(FleetMetaDataItemNames.Auction, aucId);
    }
                                                    

}
